export default {
    getLecture_id(state,payload) {
        state.lecture_id = payload
    },

    Setbook_number(state,payload) {
        state.set_book = payload
    },

    set_recommendBook(state,payload) {
        state.recommend_book = payload
    },

    search_records(state,payload) {

        state.search_records.push(payload)
    },

    search_work(state,payload) {

        state.search_work = payload
    },

    conditions_index(state,payload) {

        state.conditions_index = payload
    },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js